
<div class="login-app" *ngIf="!isAuthenticated">
  <div class="logo-login" >
    <div class="logo">
      <img src="assets/img/accesshublogo.png" alt="accesshublogo">
    </div>
  </div>
  <div class="center P10 PT30 login-body">
    <div class="sign-in">
      <h5 class="MB10">YOU ARE NOT LOGGED YET</h5>
      <p class="MB10">Please enter your credentials on the popup window</p>
      <button class="" [disabled]="isSignInDisabled" (click)= "signIn()">Sign in</button>


      <p class="MB5 font-12 color-dred">The popup window might be blocked.</p>
      <p class="MB20 font-12 color-dred"> Please allow popup windows from this site or click the "Sign in" button</p>
        </div>
    <div class="sign-out">
      <p>If your current account doesn't work you can sign out</p>
      <!-- <button class="" [disabled]="isSignOutDisabled" (click)= "signOut()"><i class="header-icon-logout"></i> Sign out</button> -->
    </div>
  </div>

</div>


